let isLogin = "0";
let loginInfo;
let integralAll=0; //总积分
let stepAll=0; //总步数
if (localStorage.isLogin) {
  isLogin = localStorage.isLogin;
}

if (localStorage.loginInfo) {
  loginInfo = JSON.parse(localStorage.loginInfo); //用户信息
}
//总积分
try{ //使用try catch是为了防止某些浏览器用户关闭本地存储功能，代码运行不了
  if(localStorage.integralAll) {
    integralAll = JSON.parse(localStorage.integralAll)
  }
}catch (e){}
//总步数
try{
  if(localStorage.stepAll) {
    stepAll = JSON.parse(localStorage.stepAll)
  }
}catch (e){}
export { isLogin, loginInfo,integralAll,stepAll};
